export default "__VITE_ASSET__DPQNImF9__"